import {ErrorHandler, Inject, Injectable} from '@angular/core';
import {WINDOW} from '@shared/services/window.service';


@Injectable({providedIn: 'root'})
export class AppGlobalErrorHandler implements ErrorHandler {
	constructor(
		@Inject(WINDOW) private window: Window
	) {
	}

	handleError(error: object) {
		console.error(error);
		// @ts-ignore
		if (this.window['newrelic']) {
			// @ts-ignore
			this.window['newrelic'].noticeError(error);
		}
	}
}
